// import { scan } from 'react-scan'; // must be imported before React and React DOM
// import { StrictMode } from "react";
import { createRoot } from 'react-dom/client';

import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/inter/800.css';

import './index.css';
import App from './App.jsx';
// import { initSentry } from './shared/config/sentry';

// if (import.meta.env.DEV === false) {
// 	initSentry();
// }
// scan({
// 	enabled: true,
// });
createRoot(document.getElementById('root')).render(<App />);
